<template>
  <Card>
    <h1 slot="Title">Functional Area Element Example</h1>
    <div slot="MainContent">
      <div class="ImageWrapper">
        <figure>
          <img :src="Image" alt="Graph">
        </figure>
      </div>
    </div>
    <div slot="Notes">
      <p><strong>Show Slide 24</strong>, <strong>Functional Area element Example</strong></p>
    </div>
  </Card>
</template>

<style scoped>
.ImageWrapper {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
}

.ImageWrapper > figure > img {
  max-width: calc(1726px / 2);
  width: 100%;
  margin-bottom: 20px;
}
</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'FunctionalAreaElementExample',
  
  data() {
    return {
      Image: require('@/assets/Functional_Area_Elements.png')
    }
  }
  
}
</script>